<template>
  <div class="app-search-tag">
    <div class="app-search-tag-each">
      <p class="app-search-tag-name">{{ tags }}</p>
      <el-radio-group style="width: 90%" v-model="rs">
        <div style="display: contents" v-on:click="selectTag('ALL')">
          <el-radio-button class="app-search-tag-radio" label="ALL"></el-radio-button>
        </div>
        <div style="display: contents" v-for="item in tagData" :key="item.id" v-on:click="selectTag(item.id)">
          <el-radio-button class="app-search-tag-radio" :label="item.name"/>
        </div>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchTag",
  props: {
    tags: String,
    tagData: Array
  },
  data() {
    return {
      rs: "ALL",
      selectId: 'ALL'
    }
  },
  watch: {
    rs() {
      this.$parent.$parent.$parent.$parent.doSearch();
    }
  },
  methods: {
    selectTag(tagId) {
      this.selectId = tagId;
    }
  }
}
</script>

<style scoped>

.app-search-tag {
  position: relative;
  text-align: center;
  padding-top: 10px;
}

.app-search-tag-each {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  line-height: 50px;
  text-align: left;
  padding-left: 25px
}

.app-search-tag-name {
  float: left;
  margin-right: 15px;
  margin-top: -8px
}

.app-search-tag-radio {
  border: 0;
  margin-bottom: 20px;
}

</style>